import React, { useEffect, useState } from "react"
import { navigate } from "gatsby"
import { languages } from "../../languages"
import { useTranslation } from "react-i18next"

const ChangeChoiceLanguage = props => {
  const [shouldBeActive, setShouldBeActive] = useState(true)
  const { t, i18n } = useTranslation()
  const [values, setValues] = useState({
    language: i18n.language,
  })
  const active = shouldBeActive ? "active" : ""
  const [isActive, setActive] = useState(false)

  useEffect(() => {
    if (props.isActive != null) {
      setShouldBeActive(props.isActive)
    }
  }, [props.isActive])

  useEffect(() => {
    const currPath = window.location.pathname
    const queryParams = window.location.search
    const currLang = currPath.split("/")[1]

    if (currLang !== values.language) {
      let modifiedLang

      modifiedLang = currPath.replace(`/${currLang}/`, `/${values.language}/`)

      if (queryParams) {
        modifiedLang = modifiedLang + queryParams
      }

      localStorage.setItem("user-picked-language", values.language)
      navigate(`${modifiedLang}`)
    }
  }, [values])

  const handleToggle = () => {
    setActive(!isActive)
  }

  function handleChange(event) {
    setValues(oldValues => ({
      ...oldValues,
      [event.target.name]: event.target.value,
    }))
  }

  return (
    <div className="search-select-lang-wrapper">
      <div id="select-lang" className={`custom-select-wrapper ${active}`}>
        <select
          className={isActive ? "clicked" : null}
          name={"language"}
          value={values.language}
          onChange={handleChange}
          onClick={handleToggle}
        >
          {languages.map(l => (
            <option key={l} value={l}>
              {t(l)}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default ChangeChoiceLanguage
